export const environment = {
  production: false,
  apiUrl: 'https://development.internal-api.moveup.care',
  authServiceUrl: 'https://development.auth-service.moveup.care',
  clientId: 'cm7vx353i00003b6msnsqxnxz',
};
